export default __webpack_public_path__ + "static/media/IC00035-talents.a422e1d9.svg";